import React from 'react'
import PropTypes from 'prop-types'

import { FormattedMessage } from '@dragonraider5/react-intl'
import { USER_NOT_FOUND } from 'inbonis-exception/lib'
import { LOGIN_PATH, REGISTER_PATH } from '../../MainRoutes/constants'
import { showFieldError, renderValidation } from '../../../utils/validations'
import { getExceptionMessage } from '../../../utils/exceptions'

import { Link } from 'react-router-dom'
import H1 from '../../../components/H1'
import { SectionWrapper } from '../../../components/Section'
import FormRow from '../../../components/FormFields/FormRow'
import PasswordField from '../../../components/FormFields/PasswordField'
import FormAction, { FormActionWrapper } from '../../../components/FormFields/FormAction'
import Button from '../../../components/Button'
import FormError from '../../../components/FormFields/FormError'
import FormLinks from '../../../components/FormFields/FormLinks'
import PasswordTip from '../../Register/PasswordTip'

import m from './messages'
import SuccessMessage from '../../../components/SuccessMessage'

const renderSuccess = __html => (
  <SuccessMessage dangerouslySetInnerHTML={{ __html }} />
)

function RecoverPasswordForm({
  values,
  errors,
  touched,
  status = {},
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit
}) {
  return (
    <SectionWrapper>
      <H1>
        <FormattedMessage {...m.resetTitle} />
      </H1>
      {status.success ? (
        <React.Fragment>
          <FormattedMessage {...m.resetSuccessMessageHTML}>
            {renderSuccess}
          </FormattedMessage>
          <FormActionWrapper>
            <Button as={Link} to='/'>
              <FormattedMessage {...m.resetContinueButton} />
            </Button>
          </FormActionWrapper>
        </React.Fragment>
      ) : (
        <form onSubmit={handleSubmit}>
          <FormRow>
            <PasswordField
              name='password'
              value={values.password}
              onChange={handleChange}
              onBlur={handleBlur}
              error={showFieldError('password', { errors, touched })}
              help={renderValidation('password', { errors, touched })}
              label={<FormattedMessage {...m.passwordField} />}
              tip={<PasswordTip value={values.password} />}
              full
            />
          </FormRow>
          {status.error && (
            <FormError>
              <FormattedMessage
                {...getExceptionMessage(status.error, {
                  [USER_NOT_FOUND]: m[USER_NOT_FOUND]
                })}
              />
            </FormError>
          )}
          <FormAction disabled={isSubmitting}>
            <FormattedMessage {...m.resetButton} />
          </FormAction>
        </form>
      )}
      <FormLinks>
        <Link to={LOGIN_PATH}>
          <FormattedMessage {...m.loginLink} />
        </Link>
        <br />
        <Link to={REGISTER_PATH}>
          <FormattedMessage {...m.registerLink} />
        </Link>
      </FormLinks>
    </SectionWrapper>
  )
}

RecoverPasswordForm.propTypes = {
  values: PropTypes.shape({
    password: PropTypes.string.isRequired
  }).isRequired,
  touched: PropTypes.objectOf(PropTypes.bool),
  errors: PropTypes.objectOf(PropTypes.string),
  isSubmitting: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired
}

export default RecoverPasswordForm
